import {
  Box,
  Card,
  CardContent,
  Chip,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { OrderFilter } from "../../../models/app/AppModels";
import { useGetOrdersQuery } from "../../../redux/reducer/features/Order/orderSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useNavigate } from "react-router-dom";

export const RecentOrders = () => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const navigate = useNavigate();
  const [orders, setOrders] = useState<any[]>([]);
  const [ordersPaging, setOrdersPaging] = useState<OrderFilter>({
    pageIndex: 0,
    pageSize: 5,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
    archivedOnly: false,
    dmsSetupId: dmsSetup?.id,
  });

  const {
    data: ordersData,
    isLoading: ordersLoading,
    refetch: refetchQOrders,
    isFetching: ordersFetching,
  } = useGetOrdersQuery(
    {
      paging: ordersPaging,
    },
    { skip: dmsSetup?.id === undefined ? true : false }
  );

  useEffect(() => {
    refetchQOrders();
  }, []);

  useEffect(() => {
    if (ordersData && ordersData.entityList) {
      setOrders(ordersData.entityList);
    }
  }, [ordersData]);

  const handleRedirect = (URL: string) => {
    navigate(URL);
  };
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" fontWeight={"bold"}>
            Recent Orders
          </Box>
          <Box>
            <Link
              onClick={() => {
                handleRedirect("Orders");
              }}
              sx={{ cursor: "pointer" }}
              variant="body2"
            >
              View All
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 1,
            minHeight: "290px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          {orders.length === 0 ? (
            <Typography mt={"130px"} style={{ fontSize: "14px" }}>
              {ordersLoading || ordersFetching
                ? "Loading data..."
                : "No data to display"}
            </Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table size="medium">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        p: 1.6,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Order Id
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", p: 1.6 }}>
                      Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", p: 1.6 }}>
                      Email
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ fontWeight: "bold", p: 1.6 }}
                    >
                      Amount($)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell sx={{ p: 1.6 }}>
                        {item.order.externalOrderNumber === 0
                          ? item.order.saleOrderId
                          : item.order.externalOrderNumber}

                        {!item.order.acknowledged && (
                          <Chip
                            label="New"
                            size="small"
                            color="info"
                            sx={{
                              marginLeft: 1,
                              height: "18px",
                              fontSize: "0.7rem",
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell sx={{ p: 1.6, whiteSpace: "nowrap" }}>
                        {item.order.customerName}
                        {!item.order.isCustomerActive && (
                          <Tooltip
                            title={"Customer is not active."}
                            placement="top-start"
                          >
                            <WarningIcon
                              fontSize="medium"
                              color="warning"
                              sx={{
                                marginLeft: 0.5,
                                verticalAlign: "middle",
                              }}
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell sx={{ p: 1.6 }}>
                        {item.order.customerEmail}
                      </TableCell>
                      <TableCell align="right" sx={{ p: 1.6 }}>
                        {item.order.amount.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
